__turbopack_context__.v({
  "icon": "SetSnsButton-module__S-JX-a__icon",
  "root": "SetSnsButton-module__S-JX-a__root",
});
